<template>
    <div>
        <ul class="bim-upload-lists">
            <li class="lists-item-container" v-for="(file, index) in uploadFileList" :key="index">
                <div class="lists-item">
                    <div :title="file.name" class="lists-name">
                        <el-checkbox
                            :disabled="file.isLocked"
                            :checked="file.isChecked"
                            @change="file.isChecked = !file.isChecked"
                        >
                            {{ file.name }}
                        </el-checkbox>
                    </div>
                    <div class="lists-size">{{ getformatSzie(file.size) }}</div>
                </div>
                <!-- 进度条 -->
                <el-progress
                    v-if="file.percentage > 0"
                    class="progress-bar"
                    :percentage="file.percentage"
                ></el-progress>
                <!-- <el-progress class="progress-bar" :percentage="file.percentage"></el-progress> -->
                <!-- <div v-show="false" class="lists-delete"><i class="el-icon-delete"></i></div> -->
                <!-- <span v-if="file.isLocked" style="color: red;">文件已被锁定</span> -->
            </li>
        </ul>
    </div>
</template>

<script>
import { formatSzie } from 'src/utils/commonUtils';

export default {
    props: {
        uploadFileList: {
            type: Array,
            default: [],
        },
    },
    methods: {
        getformatSzie(size) {
            return formatSzie(size);
        },
    },
};
</script>

<style scoped lang='stylus' rel='stylesheet/stylus'>
.lists-item-container
  display flex
  flex-direction column
  .lists-item
    display flex
    justify-content space-between
    align-items center
    padding 6px 30px
  .lists-name
    width 80%
    >>>.el-checkbox
      display flex
      align-items center
      .el-checkbox__label
        width 100%
        overflow hidden
        white-space nowrap
        text-overflow ellipsis
  .progress-bar
    width 100%
    padding 0px 20px
    background-color transparent
    box-shadow none
.lists-item-container >>> .el-progress__text
  width 45px
</style>



// WEBPACK FOOTER //
// src/pages/devCenter/consoleLab/components/upload-file-list.vue